<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <input type="file" id="___file_upload" ref="referenceUpload" accept="image/*" @change="upload" />
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
        </div>
        <div class="nav-middle">选择热门头像</div>
        <div class="nav-right">
            <span class="nav-lable ub ub-pc ub-ac" @click="save()" v-if="chosed!=4">完成</span>
            <img src="../../assets/img/返回箭头.png" class="nav-img none" />
        </div>
      </div>



      <div class="photo-box">
        <div class="photo-title ub ub-ac ub-pc">
          <img :src="photo" alt="">
        </div>

        <ul class="ub ub-pc ub-ac1 photo-sort">

          <li @click="chosesex('', 0)" :class="chosed==0 ? 'sex-on' : ''">
            <div class="ub ub-ver">
              <span>不限</span>
              <img v-if="chosed==0" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>

          <li @click="chosesex('男生', 1)" :class="chosed==1 ? 'sex-on' : ''">
            <div class="ub ub-ver">
              <span>男生</span>
              <img v-if="chosed==1" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>

          <li @click="chosesex('女生', 2)" :class="chosed==2 ? 'sex-on' : ''">
            <div class="ub ub-ver">
              <span>女生</span>
              <img v-if="chosed==2" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>

          <li @click="chosesex('会员', 3)" :class="chosed==3 ? 'sex-on' : ''" >
            <div class="ub ub-ver ub-pc ub-ac">
              <span>会员专属</span>
              <img  v-if="chosed==3" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>

          <li @click="up_img(4)"  :class="chosed==4 ? 'sex-on' : ''">
            <div class="ub ub-ver ub-pc ub-ac">
              <span>自定义</span>
              <img  v-if="chosed==4" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>

        </ul>

        <div class="ub ub-ac ub-pc" v-if="vip_level==0 && (chosed == 3  || chosed == 4)">
            <label class="vip-tip">
              此功能为会员特权功能，
              <a @click="goto_vip()" class="go-vip">点击成为会员~</a>
            </label>
        </div>

        <div class="photo-block">
          <ul class="ub ub-ac1 photo-item" v-for="(item, index) in arr" :key="index">
            <li v-for="(item_sub, index_sub) in item" :key="index_sub" :class="{'on':item_sub.on == 1}" @click="choseImg(index, index_sub,baseurl + item_sub.photo)">
                <img :src=" baseurl + item_sub.photo" class="photo" />
            </li>
          </ul>

          <div class="custom-avatar" v-if="chosed == 4">
            <span>头像预览</span>
            <div class="up-block ub ub-pc ub-ver ub-ac">
              <div class="up">
                <img :src="photo_new" class="photo-img"  />
                <img src="../../assets/img/上传.png" class="up-img" @click="upload_img()" />
              </div>
              <label >点击照相机可更换照片</label>
            </div>

            <span class="state-tip">{{tip}}</span>
            <div class="complete ub ub-pc ub-ac" @click="update_photo()" v-if="check_state!='待审核'">完成</div>
          </div>
        </div>

        <div class="ub ub-ac ub-pc">
          <div class="btn-change" @click="changeImg()" v-if="chosed != 4">
             <button class="change-item"><span>换一批</span></button>
          </div>
        </div>

        <ul class="tip" v-if="chosed == 4">
          <li class="item ub">
            <div class="tag"></div>
             <span>VIP专属自定义头像</span>
          </li>
          <br />
          <li class="item ub">
            <div class="tag"></div>
            <span>点击头像可自定义上传头像</span>
          </li>
          <br />
          <li class="item ub">
            <div class="tag"></div>
            <span>上传成功后等待系统审核功过方可显示 </span>
          </li>
           <br />
          <li class="item ub">
            <div class="tag"></div>
            <span>禁止上传色情低俗、带有联系方式等图片</span>
          </li>
        </ul>
    </div>




      <alert ref="myConfirm"></alert>
      <dlg ref="myForm_2"></dlg>
    </div>
  </template>

  <script>
  import Exif from "exif-js";
  import * as tool from "@/api/common";
  import Alert from "@/components/Alert.vue";
  import { mapMutations, mapActions } from "vuex";
  import Form from "@/components/Form";
  export default {
    components: {
      alert: Alert,
      dlg: Form
    },
    data() {
      return {
        photo_old: "",
        photo_new: "",
        photo_new_val:"",
        arr: [],
        baseurl: this.$store.state.url + "/photo/",
        sex: "",
        photo: "",
        check_state: "",
        tip:"",
        vip_level:1,
        chosed:0,
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
      this.init_page2();
    },
    methods: {
      ...mapMutations(["get", "post", "post2"]), //引入方法
      ...mapActions(["act_reload_userinfo","act_get_userinfo"]), //引入方法
      back() {
        this.$router.go(-1); //返回上一层
      },
      goto_vip() {
        this.$router.push({ name: "vip_center" });
      },
      changeImg() {
        this.init_page();
      },

      init_page() {
        var self = this;
        var count = 16;
        var sex = this.sex;
        self.get({
          url: "/App/GetPhoto/?count=" + count + "&sex=" + sex,
          success: function (data_serve) {
            for (var i in data_serve) {
              data_serve[i].on = 0;
            }
            self.arr = tool.slice_arry(data_serve, 4);
          },
          error: function (err) {},
        });
      },

      init_page2() {
        var self = this;
        var uid = self.$store.state.uid;

        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            //console.log(JSON.stringify(u));
            self.vip_level = u.vip_level;
            self.photo_old=u.photo;
            self.photo_new=u.photo;
            self.photo = u.photo;
          },
        });

        self.get({
          url: "/App/GetUser_Update/?uid=" + uid + "&field_name=photo",
          success: function (data_serve) {
            //console.log(JSON.stringify(data_serve));
            if (data_serve.val_new) {
              self.photo_new = self.$store.state.url + "/photo/" +  data_serve.val_new;
              self.check_state=data_serve.check_state;
            }
            if(data_serve.check_state=="待审核"){
              self.tip="头像上传成功，等待平台审核，审核通过后即可使用自定义头像";
            }
            if(data_serve.check_state=="失败"){
              self.tip="头像审核失败，请遵守平台相关规则，多次审核失败将影响此功能的使用";
            }
            if(data_serve.check_state=="通过"){

              self.tip="恭喜你，头像审核通过";
            }
            //console.log("old"+self.photo_old);
            //console.log("new"+self.photo_new);
          },

          error: function (err) {},
        });


      },

      chosesex(sex, chosed) {
        this.sex = sex;
        this.chosed= chosed;
        this.init_page();
      },
      up_img(chosed) {
        var skipWxCheck = this.$store.state.skipWxCheck;
        if (!skipWxCheck) {
          var wxInfo = this.$store.state.wxInfo;
          if(wxInfo == ""){
            this.show_sys_GuanzhuWx();
            return false;
          }
        }

        this.arr = [];
        this.chosed= chosed;
      },
      choseImg(index1, index2,item) {
        var a1 = this.arr.length;
        var a2 = this.arr[0].length;
        for (var i = 0; i < a1; i++) {
          for (var j = 0; j < a2; j++) {
            this.arr[i][j].on = 0;
          }
        }
        this.photo = item;
        this.arr[index1][index2].on = 1;

      },

      save() {
        if((this.chosed==3||this.chosed==4)&&this.vip_level==0){
            this.$toast.top("此为会员功能~");
            return false;
        }

        var choseImg = "";
        var a1 = this.arr.length;
        var a2 = this.arr[0].length;
        for (var i = 0; i < a1; i++) {
          for (var j = 0; j < a2; j++) {
            if (this.arr[i][j].on == 1) {
              choseImg = this.arr[i][j].photo;
            }
          }
        }

        if (choseImg == "") {
          //提示选择图片
          this.$refs.myConfirm.show("请先选择一个头像", {
            type: "alert",
            confirmText: "确定",
            titleText: "温馨提示",
            data: "",
          });
          return false;
        }

        //保存数据
        var send_data = { photo: choseImg };
        this.save_serve(send_data);
      },

      update_photo() {
         var self = this;
        if(self.vip_level==0){
          self.$toast.center("此为会员特权功能~");
          return false;
        }

        if(self.photo_new_val==""){
          self.$toast.center("请上传头像~");
           return false;
        }

        var uid = self.$store.state.uid;
        var data_send = {
          uid: uid,
          field_name: "photo",
          val_old: self.photo_old,
          val_new: self.photo_new_val,
          check_state: "待审核",
        };
        var strsend = JSON.stringify(data_send);
        //console.log(strsend);

        this.post({
          url: "/App/UpDate_User",
          data: { uid: uid, strsend: strsend },
          success: function (serve_data) {
            if (serve_data.state == "1") {
              self.$toast.center("修改成功，请等待审核~");
              self.check_state = "待审核";
              self.tip="头像上传成功，等待平台审核，审核通过后即可使用自定义头像";

              var bll_id = serve_data.id || "";
              var msg = {
                  "txt": "头像审核",
                  "desc": "你申请的头像已提交审核专员进行审核，请耐心等待一下",
                  "id": bll_id
            }
              tool.send_check_msg(self,"check_photo",msg,true);
            }
          },
        });
      },

      save_serve(send_data) {
        //后台保存信息
        var self = this;
        var uid = this.$store.state.uid;
        //var send_data = {'nick' : nick};
        var data = {
          url: "/App/User_ModifyBaseInfo",
          data: {
            uid: uid,
            data: JSON.stringify(send_data),
          },
          success: function (data_serve) {
            if (data_serve.state == "1") {
              self.act_reload_userinfo({
                uid: uid,
                success: function (info) {
                  self.back();
                },
              });
            }
          },
        };
        self.post(data);
      },

      upload_img() {
        //触发input的change事件
        var ie =
          navigator.appName == "Microsoft Internet Explorer" ? true : false;
        if (ie) {
          document.getElementById("___file_upload").click();
        } else {
          var a = document.createEvent("MouseEvents"); //FF的处理
          a.initEvent("click", true, true);
          document.getElementById("___file_upload").dispatchEvent(a);
        }
      },
      upload(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.picValue = files[0];

        var arrExt = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];
        var file_name = this.picValue.name;
        var fileExt = file_name.substr(file_name.lastIndexOf(".")).toLowerCase();

        if (arrExt.indexOf(fileExt) <= -1) {
          //上传文件格式不正确
          this.$toast.center("不支持您所选的图片格式~");
          return false;
        }

        //toast 启动动画
        this.$loading("上传中...");

        this.imgPreview(this.picValue);
      },
      postImg() {
        var self = this;

        //这里写接口
        var base64 = this.headerImage;
        let param = new FormData(); // 创建form对象
        param.append("imgFile", base64); //对应后台接收图片名

        //判断base64 是否成功, 长度>10
        if (base64.length < 10) {
          //消掉动画
          self.$loading.close();
          self.$toast.center("图片处理失败,请重新选择");
          return false;
        }

        this.post2({
          url: "/Common/UpLoadPhoto_Base64",
          data: param,
          success: function (serve_data) {
            //消掉动画
            self.$loading.close();
            //self.$toast.center('上传成功');
            var pic_url = self.$store.state.url + "/photo/" + serve_data;
            //console.log(pic_url);
            self.photo_new = pic_url;
            self.photo_new_val=serve_data;
          },

          error: function (err) {
            //消掉动画
            self.$loading.close();
            self.$toast.center("上传失败,请重新再来");
          },
        });
      },

      //关注公众号提示
      show_sys_GuanzhuWx() {
        var qrcode_url = require('../../assets/img/qrcode_xhc.jpg');
        var gzh_name = '小火柴';
        var code_link='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1NzM4MTAzOQ==#wechat_redirect';
        //加载dic信息
        var sysdic = this.$store.state.sysdic;
        if(sysdic){
          qrcode_url = sysdic.wx_gzh_qrcode;
          gzh_name = sysdic.wx_gzh_name;
        }

        var h = '<div style="line-height:1.6em;font-size:.85em;"><label style=" font-weight: bold;font-size:1.1em;">当前版本过低，<label style=" font-weight: bold;font-size:1.1em;color:red;">"自定义头像"</label>功能无法使用</label>，请关注公众号【<a style="color: rgb(186, 97, 255)" href='+code_link+'>'+ gzh_name +'<a/>】，开启自定义头像功能~<div>'
          + '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '" style="margin: 1rem 0"/></div>'
          + '<div style="line-height:1.6em; text-align:center;">长按开启自定义头像功能<div>'
        this.$refs.myForm_2.show(h, {
          type: 'alert',
          confirmText: '长按上方二维码',
          titleText: '温馨提示',
          data: ''
        });
      },

      imgPreview(file) {
        let self = this;
        let Orientation;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, "Orientation");
        });
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;
        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader();
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            let result = this.result;
            let img = new Image();
            img.src = result;
            //判断图片是否大于500k,是就直接上传，反之压缩图片
            var pic_size = ((this.result.length * 1.0) / (1024 * 1024)).toFixed(
              2
            );
            if (this.result.length <= 1 * 500 * 1024) {
              self.headerImage = this.result;

              self.postImg();
            } else {
              img.onload = function () {
                let data = tool.compress_mult(img, Orientation, 0.3);
                self.headerImage = data;
                self.postImg();
              };
            }
          };
        }
      },


    },
  };
  </script>

  <style lang="scss" scoped>
  .container {
    height: 100vh;
    background-color: #EFEFEF;
    background-image: url(../../assets/img/new2024/bg-photo.png);
    background-size: contain;
    background-repeat: no-repeat;
    
  }
  .nav-top {
    background-color: transparent;
  }

  #___file_upload {
    position: absolute;
    left: -999px;
  }
  .nav-right {
    padding-right: 0.1rem;
  }

  .nav-lable {
    width:4rem;
    height: 2rem;
    border-radius: 1rem;
    background: linear-gradient( 90deg, #8A61FF, #FE9CC0);
    font-size: 0.9rem;
  }


  .photo-box {
    margin-top: 8rem;
    padding: 2rem 0.5rem;
    min-height: 30rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    background-color: #EFEFEF;
    .photo-title {
      margin-top: -4.5rem;
      img {
        height: 5rem;
        width: 5rem;
        border-radius: 50%;
        border: 1px solid #dcdcdc;
      }
    }
    .on-img {
      width: 1.5rem;
    }
    .photo-sort {
      margin-top: 1rem;
      padding: 0.8rem 0.8rem 0.3rem 0.8rem;
      font-size: 0.9rem;
      .sex-on {
        margin-top: 0.2rem;
        font-size: 0.9rem;
        font-weight: 600;
      }
    }
    .vip-tip {
        margin-top: 0.5rem;
        color: #333;
        font-size: 0.65rem;
        margin-left: 1.25rem;
        .go-vip {
          font-size: 0.65rem;
          color: rgb(186, 97, 255);
        }
    }
    .photo-block {
      padding: 1rem 0;
      margin-top: 0.5rem;
      background-color: #FDFDFD;
      border-radius: 1rem;
      .photo-item {
        margin-bottom: 0.5rem;
        li {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .photo {
          width: 4rem;
          height: 4rem;
          border-radius: 0.5rem;
        }
        .on {
          .photo {
            width: 3.7rem;
            height: 3.7rem;
          }
          padding: 0.3rem;
          border-radius: 1rem;
          border-image: linear-gradient(86deg, rgba(162, 100, 231, 1), rgba(254, 156, 192, 1)) 2 2;
        }
      }
    }
    .btn-change {
        margin-top: 1.5rem;
        font-size: 0.75rem;
        border: none;
        border-radius: 1rem;
    }
    .change-item {
          padding: 0.5rem 1rem;
          background-color: transparent;
          position: relative;
          background: transparent;
          border: none;
          cursor: pointer;
          z-index: 1;
          span {
            color: #BA61FF;
            font-size: 0.65rem;
          }
    }
    .change-item::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 2rem;
            padding: 1px;
            background: linear-gradient(to bottom, #8A61FF, #94E7E0);
            z-index: -1;
            -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
            mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
    }
  }

  .custom-avatar {
    span {
      margin-left: 1rem;
      font-size: 0.75rem;
    }
    .up-block {
      label {
          margin-top: 1rem;
          font-size: 0.65rem;
        }
        .up {
          .photo-img {
            width: 8rem;
            height: 8rem;
            border-radius: 0.5rem;
          }
          .up-img {
            width: 2.5rem;
            height: 2.5rem;
            margin-left: -1.25rem;
            margin-bottom: -1rem;
          }
        }
    }
    .state-tip{
        display: inline-block;
        padding: 0 0 1rem .8rem;
        margin-top: 0.8rem;
        font-size: 0.75rem;
        color: #ff0000;
      }
    .complete {
      margin: 1rem;
      padding: 0.5rem 3rem;
      color: #fff;
      font-size: 1.1rem;
      border-radius: 1rem;
      background: linear-gradient( 84deg, #8A61FF 13%, #FE9CC0 91%);
    }
  }

  .tip {
    padding: 1rem 0.5rem;

    li.item {
      .tag {
        width: 0.5rem;
        height: 1rem;
        background-color: #BA61FF;
        border-radius: 0.5rem;
      }
      span {
        margin-left: 0.5rem;
        font-size: 0.75rem;
        color: #333;
      }
    }
  }


.container-dark {
  min-height: 100vh;
  background-color: #2f2e33;
  .photo-box {
    background-color: #2c2b30;
    .photo-sort {
      span {
        color: #fdfdfd;
      }
    }
    .vip-tip {
        color: #888;
    }
    .photo-block {
      background-color: #2f2e33;
      .custom-avatar {
        span {
          color: #888;
        }
        label {
          color: #888;
        }
      }
    }
    .tip {
      li.item {
        span {
          margin-left: 0.5rem;
          font-size: 0.75rem;
          color: #888;
        }
      }
    }
  }
}

</style>
